import styled from 'styled-components'

export const AIDesignBody = styled.div`
  width: 100%;
  min-height: 100%;
  background: #f5f5f5;
  position: relative;
  padding-bottom: 90px;

  @media (max-width: 1100px) {
    padding-bottom: 0;
  }
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 20px;
  padding-bottom: 20px;
  position: sticky;
  top: 0;
  z-index: 10;
  background: #f5f5f5;

  & h1 {
    font-weight: 700;
    font-size: 24px;
    line-height: 29px;
    color: #000000;
  }

  @media (max-width: 1100px) {
    padding: 9px 10px;
    position: fixed;
    top: 0;
    z-index: 999;
    background: white;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
    width: 100vw;
    box-sizing: border-box;

    & h1 {
      font-size: 16px;
      line-height: 20px;
    }
  }
`

export const BackArrowWrapper = styled.button`
  background: white;
  border: none;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);
  transform: rotate(90deg);

  img {
    width: 14px;
    height: 8px;
  }
`

export const BackButtonWrapper = styled.div`
  position: absolute;
  left: 32px;

  @media (max-width: 1100px) {
    display: none;
  }
`

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 1100px;
  margin: 0 auto;

  @media (max-width: 1100px) {
    width: 100%;
  }
`

export const FormWrapper = styled.div`
  width: 1100px;
  margin: 0 auto;
  box-sizing: border-box;
  background: white;
  padding: 50px 151px;

  @media (max-width: 1100px) {
    width: 100%;
    padding: 13px 14px;
  }
`

export const Content = styled.div`
  box-sizing: border-box;

  @media (max-width: 1100px) {
    width: 100%;
  }
`

export const SectionTitle = styled.h2`
  color: black;
  font-size: 18px;
  font-family: 'Helvetica Neue', sans-serif;
  font-weight: 700;
  line-height: 20px;
  margin: 40px 0 0 0;

  &:first-child {
    margin-top: 0;
  }

  span {
    color: #979797;
    font-size: 18px;
    font-weight: 400;
  }

  @media (max-width: 1100px) {
    font-size: 16px;

    span {
      font-size: 16px;
    }
  }
`

export const RoomImageSection = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-bottom: 40px;
  margin-top: 20px;
`

export const RoomImagePlaceholder = styled.div`
  width: 150px;
  height: 150px;
  background: #e5e5e5;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
  background-image: ${({ hasImage, imageUrl }) => (hasImage ? `url(${imageUrl})` : 'none')};
  background-size: cover;
  background-position: center;

  @media (max-width: 1100px) {
    width: 120px;
    height: 120px;
  }
`

export const ImagePlaceholderInner = styled.div`
  width: calc(100% - 12px);
  height: calc(100% - 12px);
  border: 1px dashed #8b8b8b;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 6px;

  img {
    width: 40px;
    height: 40px;
  }
`

export const ImagePreview = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

export const ReplaceImage = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 8px 16px;
  background: white;
  border-radius: 100px;
  border: 1px solid #ff5e6d;
  color: #ff5e6d;
  font-size: 14px;
  font-family: 'Helvetica Neue', sans-serif;
  font-weight: 400;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`

export const UploadIcon = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  width: 23.2px;
  height: 23.2px;
  background: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  cursor: pointer;

  .plus-h {
    width: 9.06px;
    height: 1.81px;
    background: #ff5e6d;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .plus-v {
    width: 1.81px;
    height: 9.06px;
    background: #ff5e6d;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`

export const StyleGrid = styled.div`
  display: flex;
  gap: 24px;
  align-items: flex-start;
  overflow-x: auto;
  overflow-y: visible;
  padding-bottom: 10px;
  scrollbar-width: none;
  -ms-overflow-style: none;
  padding-top: 5px;
  padding-left: 5px;

  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: 1100px) {
    gap: 16px;
  }
`

export const StyleOption = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
  transition: all 0.3s ease;
  flex-shrink: 0;
  border-radius: 12px;
  border: none;
  outline-color: #ff5e6d;

  ${({ selected }) =>
    selected &&
    `
    background: #ff5e6d;
    outline: 4px solid #ff5e6d;
  `}

  ${({ isCustom }) =>
    isCustom &&
    `
    border-radius: 8px;
  `}
`

export const StyleImage = styled.img`
  width: 150px;
  height: 150px;
  border-radius: 12px;
  object-fit: cover;
`

export const StyleContainer = styled.div`
  padding: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
`

export const CustomStyleIcon = styled.div`
  width: 150px;
  height: 150px;
  background: #e3e3e3;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
`

export const StyleName = styled.span`
  color: ${({ selected }) => (selected ? 'white' : 'black')};
  font-size: 14px;
  font-family: 'Helvetica Neue', sans-serif;
  font-weight: ${({ selected }) => (selected ? '500' : '400')};
  line-height: 24px;
  text-align: center;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const StyleViewAll = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  color: black;
  font-size: 14px;
  font-family: 'Helvetica Neue', sans-serif;
  font-weight: 400;
  cursor: pointer;

  svg {
    width: 18px;
    height: 8.72px;
  }
`

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
  margin-bottom: 20px;
`

export const RoomTypeGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 20px;

  /* Ensure 6 items per row on desktop */
  & > * {
    flex: 0 1 calc(16.666% - 10px);
    max-width: calc(16.666% - 10px);
  }

  @media (max-width: 1100px) {
    gap: 8px;

    & > * {
      flex: 0 1 calc(50% - 4px);
      max-width: calc(50% - 4px);
    }
  }

  @media (max-width: 600px) {
    & > * {
      flex: 0 1 100%;
      max-width: 100%;
    }
  }
`

export const RoomTypeChip = styled.div`
  padding: 12px 18px;
  background: ${({ selected }) => (selected ? '#ff5e6d' : '#f5f5f5')};
  color: ${({ selected }) => (selected ? 'white' : 'black')};
  border-radius: 100px;
  cursor: pointer;
  font-size: 14px;
  font-family: 'Helvetica Neue', sans-serif;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.3s ease;
  flex: 1;
  white-space: nowrap;

  img {
    width: 17px;
    height: 17px;
    object-fit: contain;
    filter: ${({ selected }) => (selected ? 'brightness(0) invert(1)' : 'none')};
    flex-shrink: 0;
  }

  @media (max-width: 1100px) {
    padding: 10px 16px;
    font-size: 12px;
    flex: none;
    width: auto;
    min-width: 120px;

    img {
      width: 14px;
      height: 14px;
    }
  }
`

export const ColorPaletteGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 20px;
  align-items: flex-start;

  @media (max-width: 1100px) {
    gap: 8px;
  }
`

export const ColorOption = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
`

export const ColorContainer = styled.div`
  width: 44px;
  height: 44px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid transparent;
  transition: border-color 0.2s ease;

  ${({ selected }) => selected && 'border-color: #ff5e6d;'}
`

export const ColorSwatch = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background-color: ${({ color }) => color};
  background-image: ${({ texture }) => (texture ? `url(${texture})` : 'none')};
  background-size: cover;
  border: ${({ border }) => (border ? '1px solid #d8d8d8' : 'none')};
`

export const ColorName = styled.span`
  color: black;
  font-size: 12px;
  font-family: 'Helvetica Neue', sans-serif;
  font-weight: 400;
  text-align: center;
`

export const GenerateButton = styled.button`
  width: 260px;
  height: 44px;
  background: linear-gradient(270deg, #ff9d74 0%, #ff5e6d 37%, #ff4f7e 75%, #ff6d90 100%);
  border-radius: 22px;
  border: none;
  color: white;
  font-size: 16px;
  font-family: 'Helvetica Neue', sans-serif;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.3s ease;

  @media (max-width: 1100px) {
    width: 100%;
  }

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(255, 94, 109, 0.3);
  }
`

export const AIIcon = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 24px;
    height: 24px;
    object-fit: contain;
    display: block;
  }
`

export const Credits = styled.span`
  color: white;
  font-size: 16px;
  font-family: 'Helvetica Neue', sans-serif;
  font-weight: 700;
`

export const CreditsDisplay = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`

export const WelcomeSection = styled.div`
  text-align: center;
  margin-bottom: 40px;
`

export const WelcomeAvatar = styled.div`
  width: 70px;
  height: 70px;
  background: #e5e5e5;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  font-size: 32px;

  img {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    object-fit: cover;
    display: block;
  }
`

export const WelcomeText = styled.p`
  color: #667085;
  font-size: 18px;
  font-family: 'Helvetica Neue', sans-serif;
  font-weight: 400;
  line-height: 27px;
  margin: 0;

  @media (max-width: 1100px) {
    font-size: 16px;
    line-height: 24px;
  }
`

// Custom Style Modal Components
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`

export const ModalContainer = styled.div`
  width: 530px;
  height: 380px;
  position: relative;
  background: white;
  border-radius: 16px;

  @media (max-width: 600px) {
    width: calc(100vw - 32px);
    height: auto;
    min-height: 320px;
    margin: 16px;
  }
`

export const ModalCloseButton = styled.button`
  width: 26px;
  height: 26px;
  position: absolute;
  right: 16px;
  top: 16px;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 14px;
    height: 14px;
  }
`

export const ModalTitle = styled.h2`
  width: 177px;
  height: 28px;
  position: absolute;
  left: 50%;
  top: 20px;
  transform: translateX(-50%);
  text-align: center;
  color: #030303;
  font-size: 24px;
  font-family: 'Helvetica Neue', sans-serif;
  font-weight: 500;
  margin: 0;
  line-height: 28px;
`

export const ModalLabel = styled.div`
  position: absolute;
  left: 30px;
  top: 70px;
  color: black;
  font-size: 18px;
  font-family: 'Helvetica Neue', sans-serif;
  font-weight: 700;
  line-height: 20px;
`

export const ModalTextarea = styled.textarea`
  width: 470px;
  height: 160px;
  position: absolute;
  left: 30px;
  top: 105px;
  background: white;
  border-radius: 5px;
  border: 1px solid #e5e5e5;
  padding: 12px 18px;
  box-sizing: border-box;
  font-size: 14px;
  font-family: 'Helvetica Neue', sans-serif;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.14px;
  color: #030303;
  resize: none;
  outline: none;

  &::placeholder {
    color: #9b9b9b;
  }

  &:focus {
    border-color: #ff5e6d;
  }

  @media (max-width: 600px) {
    width: calc(100% - 60px);
    top: 95px;
  }
`

export const ModalSaveButton = styled.button`
  width: 290px;
  height: 50px;
  position: absolute;
  left: 50%;
  top: 300px;
  transform: translateX(-50%);
  background: #ff5e6d;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08);
  border-radius: 91px;
  border: none;
  color: white;
  font-size: 16px;
  font-family: 'Helvetica Neue', sans-serif;
  font-weight: 700;
  line-height: 19px;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background: #e54c5c;
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }

  @media (max-width: 600px) {
    width: calc(100% - 60px);
    top: 280px;
  }
`

// Room Image Selection Modal Components
export const RoomImageModalContainer = styled.div`
  width: 530px;
  height: 500px;
  position: relative;
  background: white;
  box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.15);
  border-radius: 16px;

  @media (max-width: 600px) {
    width: calc(100vw - 32px);
    height: auto;
    min-height: 400px;
    margin: 16px;
  }
`

export const RoomImageModalTitle = styled.h2`
  width: 186px;
  height: 28px;
  position: absolute;
  left: 50%;
  top: 120px;
  transform: translateX(-50%);
  text-align: center;
  color: #030303;
  font-size: 24px;
  font-family: 'Helvetica Neue', sans-serif;
  font-weight: 700;
  margin: 0;
  line-height: 28px;
`

export const RoomImageModalDescription = styled.p`
  width: 396px;
  position: absolute;
  left: 50%;
  top: 180px;
  transform: translateX(-50%);
  text-align: center;
  color: #030303;
  font-size: 20px;
  font-family: 'Helvetica Neue', sans-serif;
  font-weight: 400;
  line-height: 30px;
  margin: 0;
`

export const RoomImageModalButtons = styled.div`
  width: 290px;
  position: absolute;
  left: 50%;
  top: 294px;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (max-width: 600px) {
    width: calc(100% - 60px);
    top: 260px;
  }
`

export const RoomImageModalButton = styled.button`
  width: 290px;
  height: 50px;
  background: ${({ outlined }) => (outlined ? 'white' : '#ff5e6d')};
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08);
  border-radius: 91px;
  border: ${({ outlined }) => (outlined ? '2px solid #ff5e6d' : 'none')};
  color: ${({ outlined }) => (outlined ? '#ff5e6d' : 'white')};
  font-size: 16px;
  font-family: 'Helvetica Neue', sans-serif;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &:hover {
    background: ${({ outlined }) => (outlined ? '#fff5f5' : '#e54c5c')};
    transform: translateY(-1px);
  }

  input[type='file'] {
    display: none;
  }

  @media (max-width: 600px) {
    width: 100%;
  }
`

export const RoomImageModalButtonIcon = styled.div`
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    filter: ${({ outlined }) => (outlined ? 'none' : 'brightness(0) invert(1)')};
  }
`

// Styles "View All" Modal Components
export const StylesModalContainer = styled.div`
  width: 1180px;
  height: 920px;
  position: relative;
  background: white;
  border-radius: 12px;
  overflow: hidden;

  @media (max-width: 1240px) {
    width: calc(100vw - 32px);
    height: calc(100vh - 64px);
    max-height: 920px;
    margin: 16px;
  }

  @media (max-width: 600px) {
    width: calc(100vw - 16px);
    height: calc(100vh - 32px);
    margin: 8px;
  }
`

export const StylesModalHeader = styled.div`
  position: relative;
  height: 101px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 36px;
`

export const StylesModalTitle = styled.h2`
  position: absolute;
  left: 50%;
  top: 36px;
  transform: translateX(-50%);
  margin: 0;
  color: black;
  font-size: 24px;
  font-family: 'Helvetica Neue', sans-serif;
  font-weight: 700;
  letter-spacing: 0.24px;
  text-align: center;
`

export const StylesApplyButton = styled.button`
  position: absolute;
  right: 36px;
  top: 36px;
  height: auto;
  padding: 0;
  background: transparent;
  border: none;
  color: #ff5e6d;
  font-size: 24px;
  font-family: 'Helvetica Neue', sans-serif;
  font-weight: 700;
  letter-spacing: 0.24px;
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  @media (max-width: 600px) {
    font-size: 18px;
    right: 16px;
    top: 16px;
  }
`

export const StylesGridLarge = styled.div`
  position: absolute;
  left: 0;
  top: 101px;
  right: 0;
  height: calc(100% - 125px);
  overflow-y: auto;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;

  @media (max-width: 1240px) {
    padding: 16px;
  }

  @media (max-width: 600px) {
    padding: 12px;
  }
`

export const StylesGridInner = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 280px);
  gap: 32px 32px;
  max-width: 100%;
  width: fit-content;

  @media (max-width: 1240px) {
    grid-template-columns: repeat(3, 240px);
    gap: 24px 24px;
  }

  @media (max-width: 800px) {
    grid-template-columns: repeat(2, 240px);
    gap: 24px 24px;
  }

  @media (max-width: 600px) {
    grid-template-columns: repeat(2, 200px);
    gap: 16px 16px;
  }

  @media (max-width: 480px) {
    grid-template-columns: repeat(2, 160px);
    gap: 12px 12px;
  }
`

export const StyleCardLarge = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  cursor: pointer;
  user-select: none;
  border-radius: 16px;
  transition: all 0.3s ease;
  position: relative;
  width: 280px;
  margin: 0;

  ${({ selected }) =>
    selected &&
    `
    background: #ff5e6d;
    outline: 4px solid #ff5e6d;
    border-radius: 16px;
  `}

  @media (max-width: 1240px) {
    width: 240px;
  }

  @media (max-width: 600px) {
    width: 200px;
  }

  @media (max-width: 480px) {
    width: 160px;
  }
`

export const StyleImageLarge = styled.img`
  width: 100%;
  height: auto;
  aspect-ratio: 1;
  border-radius: 16px;
  object-fit: cover;
  display: block;
`

export const CustomStyleLarge = styled.div`
  width: 100%;
  aspect-ratio: 1;
  background: #e3e3e3;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 64px;

  @media (max-width: 1240px) {
    font-size: 56px;
  }

  @media (max-width: 600px) {
    font-size: 32px;
  }
`

export const StyleNameLarge = styled.div`
  width: 280px;
  padding: 12px 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ selected }) => (selected ? 'white' : 'black')};
  font-size: 20px;
  font-family: 'Helvetica Neue', sans-serif;
  font-weight: ${({ selected }) => (selected ? '500' : '400')};
  line-height: 24px;
  text-align: center;
  box-sizing: border-box;

  @media (max-width: 1240px) {
    width: 240px;
    font-size: 18px;
    padding: 10px 8px;
  }

  @media (max-width: 600px) {
    width: 200px;
    font-size: 14px;
    padding: 8px 4px;
  }

  @media (max-width: 480px) {
    width: 160px;
    font-size: 12px;
    padding: 6px 4px;
  }
`

// AI Result Modal Components
export const ResultModalContainer = styled.div`
  width: 698px;
  min-height: 748px;
  height: auto;
  position: relative;
  background: white;
  border-radius: 16px;
  overflow: hidden;

  @media (max-width: 768px) {
    width: calc(100vw - 32px);
    height: auto;
    min-height: 600px;
    max-height: calc(100vh - 64px);
    margin: 16px;
  }
`

export const ResultModalHeader = styled.div`
  width: 100%;
  height: 50px;
  background: #f5f5f5;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const ResultModalTitle = styled.div`
  color: black;
  font-size: 18px;
  font-family: 'Helvetica Neue', sans-serif;
  font-weight: 500;
  letter-spacing: 0.18px;
`

export const ResultModalCloseButton = styled.button`
  width: 26px;
  height: 26px;
  position: absolute;
  right: 12px;
  top: 12px;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 14px;
    height: 14px;
  }
`

export const ResultImageSection = styled.div`
  width: 100%;
  height: 392px;
  background: white;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const ResultImage = styled.img`
  width: 360px;
  height: 360px;
  object-fit: cover;
  border-radius: 8px;

  @media (max-width: 768px) {
    width: 280px;
    height: 280px;
  }

  @media (max-width: 480px) {
    width: 240px;
    height: 240px;
  }
`

export const LoadingContainer = styled.div`
  width: 360px;
  height: 360px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  border-radius: 8px;
  gap: 20px;

  @media (max-width: 768px) {
    width: 280px;
    height: 280px;
  }

  @media (max-width: 480px) {
    width: 240px;
    height: 240px;
  }
`

export const LoadingSpinner = styled.div`
  width: 40px;
  height: 40px;
  border: 4px solid #e5e5e5;
  border-top: 4px solid #ff5e6d;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`

export const LoadingText = styled.div`
  color: #666;
  font-size: 16px;
  font-family: 'Helvetica Neue', sans-serif;
  font-weight: 500;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`

export const ErrorContainer = styled.div`
  width: 360px;
  height: 360px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fff5f5;
  border: 1px solid #ffcccc;
  border-radius: 8px;
  gap: 16px;
  padding: 20px;
  box-sizing: border-box;

  @media (max-width: 768px) {
    width: 280px;
    height: 280px;
  }

  @media (max-width: 480px) {
    width: 240px;
    height: 240px;
    padding: 16px;
  }
`

export const ErrorText = styled.div`
  color: #d32f2f;
  font-size: 14px;
  font-family: 'Helvetica Neue', sans-serif;
  font-weight: 500;
  text-align: center;
  line-height: 1.4;
`

export const RetryButton = styled.button`
  padding: 8px 16px;
  background: #ff5e6d;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-family: 'Helvetica Neue', sans-serif;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background: #e54c5c;
  }
`

export const ResultBottomSection = styled.div`
  width: 100%;
  height: 306px;
  background: #f5f5f5;
  position: relative;
  padding: 20px 20px 20px 20px;
  box-sizing: border-box;
`

export const RegenerateTitle = styled.div`
  color: black;
  font-size: 18px;
  font-family: 'Helvetica Neue', sans-serif;
  font-weight: 500;
  margin-bottom: 20px;
`

export const StylesPreviewRow = styled.div`
  display: flex;
  gap: 16px;
  align-items: flex-start;
  overflow-x: auto;
  padding: 5px 0 15px 0;
  scrollbar-width: none;
  -ms-overflow-style: none;
  margin: -5px -20px -15px -20px;

  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: 768px) {
    gap: 12px;
    padding: 4px 0 12px 0;
    margin: -4px -20px -12px -20px;
  }
`

export const StylePreviewCard = styled.div`
  flex-shrink: 0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  display: flex;
  flex-direction: column;
  width: 116px;

  &:first-child {
    margin-left: 20px;
  }

  &:last-child {
    margin-right: 20px;
  }

  ${({ selected }) =>
    selected &&
    `
    background: #ff5e6d;
    outline: 3px solid #ff5e6d;
  `}

  @media (max-width: 768px) {
    width: 100px;
  }

  @media (max-width: 480px) {
    width: 80px;
  }
`

export const StylePreviewImage = styled.img`
  width: 100%;
  height: 116px;
  border-radius: 8px;
  object-fit: cover;
  display: block;

  @media (max-width: 768px) {
    height: 100px;
  }

  @media (max-width: 480px) {
    height: 80px;
  }
`

export const StylePreviewName = styled.div`
  width: 100%;
  padding: 4px 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ selected }) => (selected ? 'white' : 'black')};
  font-size: 13px;
  font-family: 'Helvetica Neue', sans-serif;
  font-weight: ${({ selected }) => (selected ? '500' : '400')};
  line-height: 24px;
  text-align: center;
  box-sizing: border-box;
  min-height: 32px;

  @media (max-width: 768px) {
    font-size: 12px;
    min-height: 28px;
  }

  @media (max-width: 480px) {
    font-size: 11px;
    min-height: 24px;
    padding: 3px 4px;
  }
`

export const ResultButtonsSection = styled.div`
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 24px;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
    width: calc(100% - 40px);
  }
`

export const RegenerateButton = styled.button`
  width: 236px;
  height: 38px;
  background: white;
  border-radius: 22px;
  border: 1.5px solid #ff5e6d;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover:not(:disabled) {
    background: #fff5f5;
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`

export const RegenerateButtonText = styled.span`
  color: #ff5e6d;
  font-size: 13px;
  font-family: 'Helvetica Neue', sans-serif;
  font-weight: 700;
`

export const CoinIcon = styled.div`
  width: 22px;
  height: 22px;
  background: #fedb41;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 16px;
    height: 16px;
  }
`

export const PostButton = styled.button`
  width: 236px;
  height: 38px;
  background: #ff5e6d;
  border-radius: 37px;
  border: 2px solid #ff5e6d;
  color: white;
  font-size: 13px;
  font-family: 'Helvetica Neue', sans-serif;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover:not(:disabled) {
    background: #e54c5c;
    border-color: #e54c5c;
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background: #ccc;
    border-color: #ccc;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`
